<template>
  <div class="layout">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="220px" class="aside">
        <div class="logo">
          <h3>省心记工记账</h3>
        </div>
        <el-menu
          :default-active="activeMenu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router
        >
          <el-menu-item index="/dashboard">
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </el-menu-item>
          
          <el-menu-item index="/user">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </el-menu-item>
          
          <el-menu-item index="/team">
            <i class="el-icon-s-custom"></i>
            <span>项目管理</span>
          </el-menu-item>
          
          <el-menu-item index="/work">
            <i class="el-icon-s-order"></i>
            <span>工时管理</span>
          </el-menu-item>

          <el-menu-item index="/advance">
            <i class="el-icon-money"></i>
            <span>借支管理</span>
          </el-menu-item>

          <el-menu-item index="/settlement">
            <i class="el-icon-s-finance"></i>
            <span>结算管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <!-- 主内容区 -->
      <el-container>
        <!-- 头部 -->
        <el-header class="header">
          <div class="header-left">
            <h4>{{ $route.meta.title }}</h4>
          </div>
          <div class="header-right">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="el-icon-user-solid"></i>
                {{ adminInfo.realName || '管理员' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        
        <!-- 内容 -->
        <el-main class="main">
          <router-view />
        </el-main>
        
        <!-- 底部备案号 -->
        <el-footer class="footer" height="40px">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41020202001074" target="_blank" rel="nofollow">
            豫ICP备2026017049号-1
          </a>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41020202001074" rel="noreferrer" target="_blank">
            <img src="/images/beian.png" alt="备案" class="beian-icon" />
            豫公网安备41020202001074号
          </a>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  computed: {
    ...mapGetters(['adminInfo']),
    
    activeMenu() {
      return this.$route.path
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('logout')
          this.$router.push('/login')
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.layout {
  height: 100vh;
  overflow: hidden;
  
  .el-container {
    height: 100%;
  }
  
  .aside {
    background-color: #304156;
    height: 100vh;
    overflow-y: auto;
    
    .logo {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #263445;
      
      h3 {
        color: #fff;
        font-size: 20px;
        font-weight: 600;
      }
    }
    
    .el-menu {
      border: none;
    }
  }
  
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 20px;
    
    .header-left {
      h4 {
        font-size: 18px;
        font-weight: 500;
      }
    }
    
    .header-right {
      .el-dropdown-link {
        cursor: pointer;
        display: flex;
        align-items: center;
        
        i:first-child {
          margin-right: 8px;
          font-size: 18px;
        }
      }
    }
  }
  
  .main {
    background: #f0f2f5;
    padding: 20px;
    overflow-y: auto;
  }
  
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-top: 1px solid #e8e8e8;
    
    a {
      color: #999;
      font-size: 12px;
      text-decoration: none;
      display: flex;
      align-items: center;
      
      &:hover {
        color: #666;
      }
    }
    
    .beian-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }
}
</style>
